import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ViewChild, inject } from '@angular/core';
import { AsyncPipe, DatePipe } from '@angular/common';
import { Channel } from 'stream-chat';
import { ChannelService } from 'stream-chat-angular';
import {
  getChannelCreatedAtDate,
  getChannelDisplayName,
  getSortedMemberRows,
} from './channel-info-drawer.mappers';

@Component({
  selector: 'atom-channel-info-drawer',
  standalone: true,
  imports: [AsyncPipe, DatePipe],
  templateUrl: './channel-info-drawer.component.html',
  styleUrl: './channel-info-drawer.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChannelInfoDrawerComponent {
  @ViewChild('channelInfoDrawerDialog', { static: false })
  channelInfoDrawerDialog?: ElementRef<HTMLDialogElement>;

  private channelService = inject(ChannelService);

  activeChannel$ = this.channelService.activeChannel$;

  closeDrawer() {
    this.channelInfoDrawerDialog?.nativeElement?.close();
  }

  channelName(channel: Channel | null | undefined) {
    return getChannelDisplayName(channel ?? undefined);
  }

  createdAtDate(channel: Channel | null | undefined) {
    return getChannelCreatedAtDate(channel ?? undefined);
  }

  membersList(channel: Channel | null | undefined) {
    return getSortedMemberRows(channel?.state?.members);
  }
}
